import React from 'react';
import { User, ChevronRight, ArrowRight, Sun, Moon } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useTheme } from "../../hooks/useTheme";
import "../../css/HRPortal.css";

const Header = ({ candidateName, roundName, isWhiteLabelingEnable = false }) => {
  const { theme, toggleTheme } = useTheme();
  
  // const getInitials = (name) => {
  //   if (!name) return '';
  //   const names = name.trim().split(' ');
  //   const initials = names
  //     .slice(0, 2)
  //     .map((word) => word[0]?.toUpperCase())
  //     .join('');
  //   return initials;
  // };
  
  const { logoCompact, logoPrimary, logoPrimaryDark, brandingLogo } = useSelector((state) => state.miscSlice);

  const getCurrentLogo = () => {
    if (brandingLogo) {
      if (theme === 'dark' && logoPrimaryDark) {
        return logoPrimaryDark;
      }
      return logoPrimary;
    }   
    return theme === 'dark' ? '/genie-demo-logo.png' : '/genie-demo-logo-black.png';
  };
  
  return (
    <header className="relative p-0.5">
      {/* Gradient background with blur effect */}
      <div className={`absolute inset-0 ${theme === 'light' ? 'grad' : 'bg-gradient-to-r from-[#3ECFDA]/10 to-[#0952DA]/10 backdrop-blur-sm'}`} />
      <div className="relative px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4 justify-between w-full">
          
          <div className='flex items-center gap-4'>
            
            <img 
              src={getCurrentLogo()} 
              alt="Company Logo" 
              className={brandingLogo ? 'h-7' : "h-7"} 
            />
          </div>
          <div className="flex items-center gap-3">
            {/* <div className={`w-7 h-7 rounded-full flex items-center justify-center p-1 bg-gradient-to-r from-[#2F64FF] to-[#FB54AE]`}>
              <span className={`text-xs font-medium text-white`}>
                {getInitials(candidateName)}
              </span>
            </div> */}
            <div>
              <p className={`${theme === 'light' ? 'text-textPrimary' : 'text-white'} font-medium text-[0.9375rem]`}>{candidateName}</p>
            </div>
              <div
                onClick={toggleTheme}
                className="relative w-12 h-6 rounded-full cursor-pointer bg-gradient-to-r from-gray-200 to-gray-300 dark:from-slate-700 dark:to-slate-900 transition-all"
              >
                <div
                  className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white flex items-center justify-center
                    transition-all duration-300
                    ${theme === "dark" ? "translate-x-6 rotate-180" : "translate-x-0 rotate-0"}
                  `}
                >
                  {theme === "dark" ? (
                    <Moon className="w-3 h-3 text-slate-700" />
                  ) : (
                    <Sun className="w-3 h-3 text-yellow-500" />
                  )}
                </div>
              </div>        
            </div>
        </div>
        {/* Center - Round info with decorative elements */}
        {roundName && (
          <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2">
            <div className="flex items-center gap-2 px-4 py-1">
              <div className="flex items-center gap-1 text-gray-200">
                <span className={`${theme === 'light' ? 'text-textPrimary' : ''} font-medium text-sm`}>Current Assessment</span>
                <ArrowRight className={`${theme === 'light' ? 'text-textPrimary' : ''} w-3 h-3`} />
                <span className={`${theme === 'light' ? 'text-textPrimary' : ''} font-medium text-sm`}>
                  {roundName}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
export default Header;